module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/bad-hair-days/"},"excerpt":"Have you ever had a bad hair day? Most days, it seems no matter how much I preen, I just cannot get my mane to settle down. I’ve tried…","timeToRead":1,"frontmatter":{"title":"Bad Hair Days","tags":["big cats","felines","grooming","hair care","mammals"]}}}]}},"pathContext":{"tag":"grooming"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-grooming.json
// module id = 762
// module chunks = 195851832060080